import { render, staticRenderFns } from "./PlanejamentoContratoFormAcoesApuracoesAgrupadas.vue?vue&type=template&id=55ad3aae"
import script from "./PlanejamentoContratoFormAcoesApuracoesAgrupadas.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoFormAcoesApuracoesAgrupadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports